import { render, staticRenderFns } from "./Knowledges.vue?vue&type=template&id=7a6afa79&lang=pug"
import script from "./Knowledges.vue?vue&type=script&lang=js"
export * from "./Knowledges.vue?vue&type=script&lang=js"
import style0 from "./Knowledges.vue?vue&type=style&index=0&id=7a6afa79&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports